module.exports = __webpack_public_path__ + "static/img/about_authority_06_zh.2a70189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_authority_06_zh.png
// module id = 0pvk
// module chunks = 34